const DEFAULT_SCROLL_DELAY = 180;
const DEFAULT_SCROLL_OFFSET = 24;

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function getElement(target) {
  if (!isBrowser()) return null;

  if (!target) return null;

  if (typeof target === "string") {
    return document.querySelector(target);
  }

  if (target instanceof HTMLElement) {
    return target;
  }

  return null;
}

export function scrollToPosition(position, options = {}) {
  if (!isBrowser()) return;

  const {
    delay = DEFAULT_SCROLL_DELAY,
    behavior = "smooth",
  } = options;

  const top = Math.max(Number(position) || 0, 0);

  window.setTimeout(() => {
    window.scrollTo({
      top,
      behavior,
    });
  }, delay);
}

export function scrollToElement(target, options = {}) {
  if (!isBrowser()) return;

  const {
    delay = DEFAULT_SCROLL_DELAY,
    offset = DEFAULT_SCROLL_OFFSET,
    behavior = "smooth",
  } = options;

  const element = getElement(target);

  if (!element) return;

  const elementTop = element.getBoundingClientRect().top + window.scrollY;

  scrollToPosition(elementTop - offset, {
    delay,
    behavior,
  });
}

export function scrollToAfterElement(target, options = {}) {
  if (!isBrowser()) return;

  const {
    delay = DEFAULT_SCROLL_DELAY,
    offset = DEFAULT_SCROLL_OFFSET,
    behavior = "smooth",
  } = options;

  const element = getElement(target);

  if (!element) return;

  const elementBottom = element.getBoundingClientRect().bottom + window.scrollY;

  scrollToPosition(elementBottom - offset, {
    delay,
    behavior,
  });
}